import React from "react";
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";

interface HeaderProps {
  handleClose: () => void;
  handleTitleChange: Boolean;
}
export const Header: React.FC<HeaderProps> = ({
  handleClose,
  handleTitleChange,
}) => {
  return (
    <div className="flex justify-between items-start self-stretch flex-grow-0 flex-shrink-0 py-0.5">
      <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0 ">
        <p className="flex-grow text-xl font-semibold text-left text-textMid dark:text-textMain capitalize">
          {handleTitleChange
            ? "Invite new external reviewer"
            : "Invite registered external reviewer"}
        </p>
      </div>
      <button onClick={handleClose} type="button">
        <XCloseIcon width={24} height={24} viewBox="0 0 24 24" />
      </button>
    </div>
  );
};
